export function ProductPageEvents() {
  const TAB_COUNT_KEY = "tabCount"; // Key for storing the number of open tabs
  const SESSION_ACTIVE_KEY = "isSessionActive"; // Key for storing the state of the current session
  const LAST_ACTIVITY_KEY = "lastActivityTimestamp"; // Key for storing the time of last activity
  const SESSION_STARTED_KEY = "sessionStarted"; // Key for tracking session status in the current tab
  const INACTIVITY_TIMEOUT = 30 * 60 * 1000; // Inactivity timeout (30 minutes)

  // Events for activity tracking
  const activityEvents = [
    "mousemove",
    "keydown",
    "scroll",
    "click",
    "touchstart",
  ];

  // Timer to end the session
  let inactivityTimer;

  function sendSessionStartEvent() {
    if (window.dataLayer && window.dataLayer[0]) {
      let getProductName = window.dataLayer[0]["Products presented"];
      if (getProductName !== undefined && getProductName !== "none") {
        dataLayer.push({
          event: "EOSCOM",
          eventCategory: "EosComEvents",
          eventAction: "session_start_product",
          eventLabel: "",
          eventContent: "",
          eventPosition: getProductName,
          eventContext: "",
        });
        // console.log("Сессия началась");
      }
    }
  }

  // Function for session initialization
  function initializeSessionTracking() {
    const now = Date.now();
    const tabCount = parseInt(localStorage.getItem(TAB_COUNT_KEY) || "0", 10);
    const lastActivity = localStorage.getItem(LAST_ACTIVITY_KEY);

    // Check if a session was started in this tab
    if (!sessionStorage.getItem(SESSION_STARTED_KEY)) {
      if (
        tabCount === 0 ||
        !lastActivity ||
        now - lastActivity > INACTIVITY_TIMEOUT
      ) {
        startNewSession();
      }
      sessionStorage.setItem(SESSION_STARTED_KEY, "true"); // Set the session flag for this tab
    }

    // Increase the tab count
    localStorage.setItem(TAB_COUNT_KEY, tabCount + 1);

    // Updating the time of last activity
    updateLastActivity();

    // Set event handlers for user activity
    activityEvents.forEach((event) => {
      window.addEventListener(event, handleUserActivity);
    });

    // Add a handler to close a tab
    window.addEventListener("beforeunload", handleTabClose);

    // Timer to end the session when idle
    setInactivityTimeout();
  }

  function startNewSession() {
    sendSessionStartEvent();
    localStorage.setItem(SESSION_ACTIVE_KEY, "true");
    updateLastActivity();
  }

  function endSession() {
    // console.log("Сессия завершена из-за бездействия");
    localStorage.setItem(SESSION_ACTIVE_KEY, "false");
    localStorage.removeItem(LAST_ACTIVITY_KEY);
  }

  // tab closing processing
  function handleTabClose() {
    const tabCount = parseInt(localStorage.getItem(TAB_COUNT_KEY) || "0", 10);

    if (tabCount > 1) {
      localStorage.setItem(TAB_COUNT_KEY, tabCount - 1);
    } else {
      localStorage.setItem(TAB_COUNT_KEY, "0");
      localStorage.setItem(SESSION_ACTIVE_KEY, "false");
    }
  }

  // Function for handling user activity
  function handleUserActivity() {
    const now = Date.now();
    const lastActivity = localStorage.getItem(LAST_ACTIVITY_KEY);

    // If the user is active after the session ends, start a new one
    if (!lastActivity || now - lastActivity > INACTIVITY_TIMEOUT) {
      startNewSession();
    } else {
      updateLastActivity();
    }

    // reset the session termination timer
    setInactivityTimeout();
  }

  // updating the time of last activity
  function updateLastActivity() {
    localStorage.setItem(LAST_ACTIVITY_KEY, Date.now());
  }

  // Set a timer to end the session
  function setInactivityTimeout() {
    clearTimeout(inactivityTimer);
    inactivityTimer = setTimeout(() => {
      endSession();
    }, INACTIVITY_TIMEOUT);
  }

  initializeSessionTracking();
}
